import { debounce } from 'lodash';
export class ProductDetails {
  constructor(root) {
    this.root = root;
    this.detailsDescription = this.root.querySelector('.product__details__description');
    this.detailsDescriptionTruncated = this.root.querySelector('.product__details__truncated');
    this.detailsDescriptionTruncatedParagraph = this.root.querySelector('.product__details__truncated p');
    this.featuresAndBenefitsDiv = this.root.querySelector('.product__details__features');
    this.keyFeaturesDiv = this.root.querySelector('.product__details__features');
    this.readMore = this.root.querySelector('.product__details__read-more');

    this.toggleReadMoreDisplay();
    this.isTruncated = false;
    this.descriptionContentHeightSetup();

    this.debouncedHandleResize = debounce(this.handleResize.bind(this), 200);
    this.registerListeners();
  }

  handleResize() {
    this.descriptionContentHeightSetup();
    this.toggleReadMoreDisplay();
  }
  isElementClamped(element) {
    return element.scrollHeight > element.clientHeight;
  }

  toggleReadMoreDisplay() {
    if (this.isElementClamped(this.detailsDescriptionTruncatedParagraph) || this.featuresAndBenefitsExist()) {
      this.readMore.style.display = 'inline-flex';
    } else {
      this.readMore.style.display = 'none';
    }
  }

  descriptionContentHeightSetup() {
    this.isTruncated = false;
    //** Use this order to achieve smooth height transition and avoid layout shift on load **//
    // Get full height of description while content is hidden
    // Make the content the truncated state
    // Get the height of truncated content
    // Make the content visible

    // Reset description to truncated state
    this.detailsDescription.classList.remove('truncated');
    this.detailsDescription.style.visibility = 'hidden';
    this.detailsDescription.style.height = 'auto';
    this.readMore.textContent = 'Read More';
    this.readMore.classList.remove('point-up');
    // Run through the setup process
    this.fullHeight = this.detailsDescription.clientHeight;
    this.detailsDescription.classList.add('truncated');
    this.truncatedHeight = this.detailsDescriptionTruncated.clientHeight;
    this.detailsDescription.style.height = `${this.truncatedHeight}px`;
    this.detailsDescription.style.visibility = 'visible';
  }

  toggleContent() {
    this.detailsDescription.classList.toggle('truncated', this.isTruncated);
    this.detailsDescription.style.height = this.isTruncated ? `${this.truncatedHeight}px` : `${this.fullHeight}px`;
    this.featuresAndBenefitsDiv && this.featuresAndBenefitsDiv.setAttribute('aria-hidden', this.isTruncated);
    this.readMore.textContent = !this.isTruncated ? 'Read Less' : 'Read More';
    this.readMore.classList.toggle('point-up', !this.isTruncated);
    this.readMore.setAttribute('aria-expanded', !this.isTruncated);

    this.isTruncated = !this.isTruncated;
  }

  featuresAndBenefitsExist() {
    if (!this.keyFeaturesDiv) return false;
    return this.keyFeaturesDiv.children.length > 0;
  }

  registerListeners() {
    this.readMore.addEventListener('click', () => {
      this.toggleContent();
    });

    window.addEventListener('resize', () => {
      this.debouncedHandleResize();
    });

    window.addEventListener('load', () => {
      this.toggleReadMoreDisplay();
    });
  }

}
